// extracted by mini-css-extract-plugin
export default {"nav_main":"_2Yz6","header_main":"_3UVO","header_content":"_3Mpm","header_logo":"_1gn0","header_link":"_1tL2","header_wrapper":"_31oS"};